import { gsap, ScrollTrigger, SplitText } from "@gsap";

function initScrollText() {
	document.querySelectorAll(".scroll_text-layout .scroll-text").forEach((text) => {
		if (text.dataset.scrollTextInit) return;
		text.dataset.scrollTextInit = "true";

		gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
			const split = SplitText.create(text, { type: "words", wordsClass: "scroll-text-word" });
			const color = getComputedStyle(text).color;

			gsap.to(split.words, {
				color,
				ease: "none",
				stagger: 0.1,
				scrollTrigger: {
					trigger: text,
					start: "top 80%",
					end: "bottom 45%",
					scrub: true,
				},
			});

			return () => split.revert();
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initScrollText);
} else {
	initScrollText();
}
